import { compose, filter, isEmpty, prop, sort } from 'ramda';
import { createSelector } from 'reselect';

import { getCodelistObjectById, sortAlphabeticallyBy } from 'utils';

import { NAME } from './constants';

const empty = [];

const getRoot = prop(NAME);

export const getActiveStateIds = compose(prop('activeStateIds'), getRoot);
export const getUsedStateIds = compose(prop('usedStateIds'), getRoot);
export const getEnableSave = compose(prop('enableSave'), getRoot);

export const getStates = createSelector(
	getActiveStateIds,
	(state, contactStateCodelist) => contactStateCodelist,
	(statesIds, statesCodelist) =>
		isEmpty(statesCodelist) ? empty : statesIds.map((statusId) => getCodelistObjectById(statusId, statesCodelist)),
);

export const getUnselectedStates = createSelector(
	getActiveStateIds,
	(state, contactStateCodelist) => contactStateCodelist,
	(statesIds, statesCodelist) =>
		compose(
			sort(sortAlphabeticallyBy('shortDescription')),
			filter((state) => state.stateType !== 'SYSTEM'),
			filter((state) => !statesIds.includes(Number(state.id))),
		)(statesCodelist),
);
